/*
  Grand jeu — compteur de participations, branché de façon non-invasive :
  aucun fichier Dawn d'origine n'est modifié pour afficher ce compteur.

  1. Badge compact sur les cartes produit (grilles comme jeu-boutique.liquid) :
     lu depuis un petit JSON prix (handle -> prix en centimes) que CHAQUE section
     qui veut ce badge doit rendre elle-même, dans un conteneur portant
     data-fr-jeu-boutique, avec un data-fr-jeu-product="{{ product.handle }}"
     sur chaque carte. Rien à faire côté Dawn : on cible juste la classe .price
     déjà présente dans snippets/price.liquid pour insérer le badge juste après.

  2. Bloc complet dans le panier (tiroir + page /cart) : recalculé à partir du
     total réel du panier, lu via /cart.js au chargement puis mis à jour en
     direct grâce au bus d'évènements déjà utilisé par Dawn (subscribe /
     PUB_SUB_EVENTS, définis globalement par assets/pubsub.js et
     assets/constants.js, chargés par layout/theme.liquid — non modifié).
     Le bloc est inséré en tête de .cart-drawer__footer / .cart__footer,
     deux classes stables du panier Dawn natif.
*/

(function () {
  // Paliers de participations, attribues PAR PRODUIT selon son prix. Doit rester
  // identique au calcul de snippets/jeu-participations.liquid : l'un alimente
  // l'affichage serveur, l'autre les badges injectes et le bloc du panier. Si les
  // deux divergent, le client ne voit pas ce qui part dans la commande.
  function paliers() {
    var brut = window.frJeuPaliers || '';
    return brut
      .split(String.fromCharCode(10))
      .map(function (ligne) {
        var parts = ligne.split('|');
        if (parts.length < 2) return null;
        var seuil = parseFloat(parts[0].trim().replace(',', '.'));
        var valeur = parseInt(parts[1].trim(), 10);
        if (isNaN(seuil) || isNaN(valeur)) return null;
        return { seuilCents: Math.round(seuil * 100), valeur: valeur };
      })
      .filter(Boolean);
  }

  function computeParticipations(priceCents) {
    if (priceCents == null) return 0;

    var seuilTranche = Number(window.frJeuSeuilTranche) * 100;
    var tranche = Number(window.frJeuEuroPerTicket) * 100;
    if (seuilTranche > 0 && tranche > 0 && priceCents >= seuilTranche) {
      return Math.floor(priceCents / tranche);
    }

    var meilleur = 0;
    paliers().forEach(function (p) {
      if (priceCents >= p.seuilCents && p.valeur > meilleur) meilleur = p.valeur;
    });
    return meilleur;
  }

  // Le panier n'est plus la somme d'un total : chaque ligne est evaluee a son
  // prix unitaire, puis multipliee par sa quantite.
  function participationsPanier(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (total, item) {
      return total + computeParticipations(item.final_price) * item.quantity;
    }, 0);
  }

  function decorateGrids() {
    document.querySelectorAll('[data-fr-jeu-boutique]').forEach(function (root) {
      var dataEl = root.querySelector('[data-fr-jeu-prices]');
      if (!dataEl) return;

      var prices;
      try {
        prices = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      root.querySelectorAll('[data-fr-jeu-product]').forEach(function (item) {
        if (item.querySelector('.jeu-participations-badge')) return;

        var handle = item.getAttribute('data-fr-jeu-product');
        var count = computeParticipations(prices[handle]);
        if (count <= 0) return;

        var priceEl = item.querySelector('.price');
        if (!priceEl) return;

        var span = document.createElement('span');
        span.className = 'jeu-participations-badge';
        span.textContent = '+' + count + ' BITE' + (count > 1 ? 's' : '');
        priceEl.insertAdjacentElement('afterend', span);
      });
    });
  }

  // Le compteur affiche disparait au paiement : sans trace sur la commande, le
  // tirage du 31/10 se ferait sur un recomptage manuel, et le reglement promet
  // d'annuler les participations d'une commande remboursee. On enregistre donc le
  // nombre sur la commande elle-meme, via un attribut de panier : Shopify le
  // reporte sur la commande, visible dans l'admin et sur la confirmation.
  //
  // A savoir : un code de reduction saisi APRES le panier, directement au
  // paiement, modifie le total sans repasser par ici. L'attribut est donc une
  // trace fidele de ce que le client a vu, pas une verite comptable : au tirage,
  // recouper avec le montant reellement encaisse de chaque commande.
  var dernierAttributEnvoye = null;

  function synchroniserAttribut(count, itemCount) {
    var nom = window.frJeuAttribut;
    if (!nom) return;

    var valeur = itemCount === 0 ? '' : String(count);
    if (valeur === dernierAttributEnvoye) return;
    dernierAttributEnvoye = valeur;

    var attributs = {};
    attributs[nom] = valeur;

    fetch(cartRoute('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributs })
    }).catch(function () {
      // Un echec ici ne doit jamais bloquer l'achat : on laisse le panier tel quel.
      dernierAttributEnvoye = null;
    });
  }

  function cartBlockHtml(count) {
    return (
      '<div class="jeu-participations">' +
      '<span class="jeu-participations__label">Cette commande = <strong>participations au tirage</strong></span>' +
      '<strong class="jeu-participations__count">' + count + '</strong>' +
      '</div>' +
      '<p class="jeu-participations__note">Chaque produit donne des participations selon son prix. ' +
      'Les participations d’une commande remboursée sont annulées. ' +
      'Voir le règlement.</p>'
    );
  }

  // Le tiroir n'offre que le paiement immediat. Un lien vers le panier laisse au
  // client le temps de voir ses participations avant de payer — c'est la raison
  // d'etre du compteur. Injecte en JS pour ne pas modifier snippets/cart-drawer.liquid,
  // fichier Dawn d'origine. Dawn re-rend le tiroir a chaque mise a jour du panier,
  // d'ou la reinjection depuis updateCartBlocks.
  function ajouterLienPanier() {
    var libelle = window.frJeuLienPanier;
    if (!libelle) return;
    document.querySelectorAll('.cart-drawer__footer .cart__ctas').forEach(function (ctas) {
      if (ctas.querySelector('[data-fr-jeu-lien-panier]')) return;
      var lien = document.createElement('a');
      lien.href = cartRoute('cart');
      lien.className = 'button button--secondary';
      lien.setAttribute('data-fr-jeu-lien-panier', '');
      lien.style.marginBottom = '8px';
      lien.textContent = libelle;
      ctas.insertAdjacentElement('afterbegin', lien);
    });
  }

  function updateCartBlocks(count) {
    document.querySelectorAll('.cart-drawer__footer, .cart__footer').forEach(function (container) {
      var slot = container.querySelector('[data-fr-jeu-cart-slot]');
      if (!slot) {
        slot = document.createElement('div');
        slot.setAttribute('data-fr-jeu-cart-slot', '');
        container.insertAdjacentElement('afterbegin', slot);
      }
      slot.innerHTML = cartBlockHtml(count);
    });
    ajouterLienPanier();
  }

  function cartRoute(suffixe) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base.replace(/\/?$/, '/') + suffixe;
  }

  // Cet appel n'est plus conditionne a la presence d'un pied de panier dans la
  // page : il sert aussi a poser l'attribut de commande. Le conditionner a un
  // compteur rendu en Liquid economiserait une requete, mais une page servie
  // depuis un cache afficherait un panier vide a tort, et la commande partirait
  // sans son nombre de participations. La fiabilite prime ici sur la requete.
  function fetchCartAndUpdate() {
    fetch(cartRoute('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var count = participationsPanier(cart);
        updateCartBlocks(count);
        synchroniserAttribut(count, cart.item_count);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    decorateGrids();
    fetchCartAndUpdate();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && event.cartData.items) {
          var count = participationsPanier(event.cartData);
          updateCartBlocks(count);
          synchroniserAttribut(count, event.cartData.item_count);
        } else {
          fetchCartAndUpdate();
        }
      });
    }
  });
})();
